export default __webpack_public_path__ + "static/media/equipArmor.27a6a9db.mp3";